<template>
  <div class="bkash-callback-wrapper">
    <div class="callback-container">
      <!-- Loading State -->
      <div v-if="isProcessing" class="processing-state">
        <div class="loader-wrapper">
          <div class="payment-loader">
            <div class="spinner"></div>
          </div>
          <h3 class="processing-title">Processing Payment</h3>
          <p class="processing-text">Please wait while we verify your bKash payment...</p>
          <p class="processing-subtext">Do not close this window or press the back button.</p>
        </div>
      </div>

      <!-- Success State -->
      <div v-if="paymentSuccess" class="success-state">
        <div class="success-wrapper">
          <div class="success-icon">
            <i class="fa fa-check-circle"></i>
          </div>
          <h2 class="success-title">Payment Successful!</h2>
          <p class="success-message">Your bKash payment has been processed successfully.</p>

          <div class="payment-details">
            <div class="detail-row">
              <span class="detail-label">Bill Number:</span>
              <span class="detail-value">{{ paymentData.bill }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Amount:</span>
              <span class="detail-value">{{ paymentData.amount }} BDT</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Transaction ID:</span>
              <span class="detail-value">{{ paymentData.txn_id }}</span>
            </div>
            <div class="detail-row" v-if="paymentData.approval">
              <span class="detail-label">Approval Code:</span>
              <span class="detail-value">{{ paymentData.approval }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">Payment Date:</span>
              <span class="detail-value">{{ paymentData.paid_at }}</span>
            </div>
          </div>

          <div class="action-buttons">
            <!-- <button @click="downloadReceipt" class="btn btn-primary btn-lg">
              <i class="fa fa-download"></i> Download Receipt
            </button> -->

            <button 
                                    class="btn info-btn btn-info radius-1 align-items-center" 
                                    @click="downloadPaySlip({
                                      unit:paymentData.unit,
                                      bill_status:'confirmed',
                                      application_status:paymentData.approval,
                                      bill_number:paymentData.bill,                                
                                      agent:'bKash',
                                      amount:paymentData.amount,
                                      paid_at:paymentData.paid_at
                                    })"
                                    :disabled="downloadingBills[paymentData.bill]"
                                    type="button"
                                  >
                                    <!-- Icon -->
                                    <i 
                                      :class="downloadingBills[paymentData.bill] ? 'fa fa-spinner fa-spin' : 'fa fa-download'" 
                                      aria-hidden="true"
                                      style="font-size: 1.2em; margin-right: 8px;"
                                    ></i>

                                    <!-- Text -->
                                    <span style="font-size: 0.85rem;">
                                      {{ downloadingBills[paymentData.bill] ? paySlipProgresse : 'Download Payment Receipt' }}
                                    </span>
                                  </button>
            <button @click="goToProfile" class="btn btn-secondary btn-lg">
              <i class="fa fa-user"></i> Go to Profile
            </button>
          </div>
        </div>
      </div>

      <!-- Error State -->
      <div v-if="paymentError" class="error-state">
        <div class="error-wrapper">
          <div class="error-icon">
            <i class="fa fa-times-circle"></i>
          </div>
          <h2 class="error-title">Payment Failed</h2>
          <p class="error-message">Unfortunately, your bKash payment could not be completed.</p>

          <div class="error-details">
            <div class="alert alert-danger">
              <strong>Error Reason:</strong><br>
              {{ errorData.reason }}
            </div>
          </div>

          <div class="help-text">
            <h5>What to do next:</h5>
            <ul>
              <li>Please try again after some time</li>
              <li>Ensure you have sufficient balance in your bKash account</li>
              <li>Check if you completed the payment on the bKash gateway</li>
              <li>If the problem persists, contact the helpdesk with the error details above</li>
            </ul>
          </div>

          <div class="action-buttons">
            <button @click="retryPayment" class="btn btn-primary btn-lg">
              <i class="fa fa-refresh"></i> Try Again
            </button>
            <button @click="goToProfile" class="btn btn-secondary btn-lg">
              <i class="fa fa-arrow-left"></i> Back to Profile
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import iziToast from 'izitoast';
import { GET_GCE_APPLICANT_PROFILE, GET_GCE_BILL_INFO_BY_APP_ID } from '../../const/api';
import { GET } from '../../utils/GCERequest';
import { generateReceipt, prepareReceiptDataFromLegacy, RECEIPT_PRESETS } from '../../utils/ReceiptGenerator'

import PayslipGenerator from '@/utils/PayslipGenerator'

export default {
  name: 'GCEBkashCallback',
  data() {
    return {
      isProcessing: true,
      paymentSuccess: false,
      paymentError: false,
      paymentData: {
        bill: '',
        amount: '',
        txn_id: '',
        approval: '',
        paid_at: '',
        unit: '',
        student_name: '',
        father_name: '',
        user_id: ''
      },
      errorData: {
        reason: '',
        code: ''
      },
      paymentID: '',
      status: '',

      isDownloadingPaySlip: false,
      paySlipProgresse: 'Preparing...',
      downloadingBills: {}
    }
  },
  computed: {
    gceToken() {
      return this.$root.$store.getters.getGceToken;
    },
    gceUser() {
      return this.$root.$store.getters.getGceUser;
    }
  },
  mounted() {
    this.processCallback();
  },
  methods: {
    async downloadPaySlip(paymentReceipe) {

      const billNumber = paymentReceipe.bill_number

      // Skip if already downloading
      if (this.downloadingBills[billNumber]) return
      // if (this.isDownloadingPaySlip) {
      //   return
      // }

      //this.isDownloadingPaySlip = true
      this.$set(this.downloadingBills, billNumber, true)
      this.paySlipProgresse = 'Preparing...'

      try {
        await PayslipGenerator.generatePayslip(
          {
            name:this.paymentData.student_name,
            father_name:this.paymentData.father_name,
            userID:this.paymentData.user_id
          },
          paymentReceipe,
          'PAID',
          (message, progress) => {
            this.paySlipProgresse = message
          },
          (error) => {
            console.error('Payment Receipet generation error:', error)
            this.$iziToast.error({
              title: 'Error',
              message: error.message || 'Failed to generate Payment Receipet. Please try again.'
            })
          }
        )

        // Success notification
        this.$iziToast.success({
          title: 'Success',
          message: 'Payment Receipet downloaded successfully!'
        })
      } catch (error) {
        console.error('Payment Receipet download error:', error)
        this.$iziToast.error({
          title: 'Error',
          message: error.message || 'Failed to download Payment Receipet. Please try again.'
        })
      } finally {
        //this.isDownloadingPaySlip = false
        this.$set(this.downloadingBills, billNumber, false)
        this.paySlipProgresse = 'Preparing...'
      }
    },
    async processCallback() {
      try {
        // Get parameters from URL - backend passes all payment data
        const urlParams = new URLSearchParams(window.location.search);
        this.status = urlParams.get('status') || '';
        this.paymentID = urlParams.get('paymentID') || '';

        // Check for explicit failure/cancel status
        if (this.status === 'failure' || this.status === 'cancel') {
          const errorReason = urlParams.get('reason') ||
            (this.status === 'cancel' ? 'Payment was cancelled by user.' : 'Payment failed at bKash gateway.');
          this.showError(errorReason, this.status.toUpperCase());
          return;
        }

        // Check if we have payment data in URL (from backend)
        const billFromUrl = urlParams.get('bill');
        const txnIdFromUrl = urlParams.get('txnId');
        const amountFromUrl = urlParams.get('amount');
        const unitFromUrl = 'GCE Equivalence';

        if (this.status === 'success' && billFromUrl) {
          // Backend passed payment data - use it directly
          await this.fetchApplicantDetails(billFromUrl, txnIdFromUrl, amountFromUrl, unitFromUrl);
        } else if (this.status === 'success') {
          // Fallback: fetch from database if URL params incomplete
          await this.fetchRecentPayment();
        } else {
          this.showError('Invalid payment status. Please check your profile or contact helpdesk.', 'INVALID_STATUS');
        }

      } catch (error) {
        console.error('Callback processing error:', error);
        this.showError('An unexpected error occurred while processing your payment', 'CALLBACK_ERROR');
      }
      finally {
        this.isProcessing = false;
      }
    },
    async fetchApplicantDetails(bill, txnId, amount, unit) {
      try {
        const token = this.gceToken


        // console.log(this.$root.$store.getters)

        if (!token) {
          this.$router.push('/gce/login');
          // return
        }

        const appId = (this.gceUser || {}).application_id || '';
        this.applicationId = appId;

        if (!appId) {
          this.loadingError = 'Application ID not found'
          this.$router.push('/gce/login')
          return;
        }
        // Make API call to fetch applicant details
        const apiURL = `${GET_GCE_APPLICANT_PROFILE}/${appId}`
        const response = await GET(apiURL)
        // console.log(response)

        // Handle authentication errors
        if (response.status === 401 || response.status === 403) {
          await this.$root.$store.dispatch('UPDATE_GCE_AUTH_RESET');
          this.$router.push('/gce/login');
          return;
        }

        if (response.status !== 200) {
          // throw new Error(`Failed to fetch applicant details: ${response.statusText}`);
          // console.log(response.statusText);
        }

        const result = response.data

        if (result) {
          const applicantId = result.applicant_id || '';

          // Basic applicant info for display
          this.paymentData = {
            bill: bill,
            amount: amount,
            txn_id: txnId,
            approval: '',
            paid_at: new Date().toLocaleString(),
            unit: unit,
            student_name: result.name || '',
            father_name: result.father_name || '',
            user_id: appId || ''
          }


          // Fetch latest bill info for this applicant and verify status
          try {
            if (appId) {
              const billResp = await GET(`${GET_GCE_BILL_INFO_BY_APP_ID}${appId}`);
              let latest = null
              if (billResp && billResp.data) {
                latest = billResp.data.data;
              }

              if (!latest) {
                this.showError('No bill information found for this application', 'NO_BILL');
                return;
              }
              const apiStatus = (latest.status || '').toString().toLowerCase();

                // console.log(latest)

              if (latest.bill_number === bill) {
                // Normalize values for comparison
                const latestTxn = (latest.transaction_code || '');
                const latestAmount = ((latest.fee !== undefined ? latest.fee : latest.amount) || '').toString();
                const providedTxn = (txnId || '');
                const providedAmount = (amount || '').toString();

                // If txnId or amount provided in URL, ensure they match the latest record when available
                if (providedTxn && latestTxn && providedTxn !== latestTxn) {
                  this.showError('Transaction ID does not match latest record.', 'TXN_MISMATCH');
                  return;
                }
                if (providedAmount && latestAmount && providedAmount !== latestAmount) {
                  this.showError('Amount does not match latest record.', 'AMOUNT_MISMATCH');
                  return;
                }
                if(latest.payment_id !== this.paymentID) {
                  this.showError('Payment ID does not match latest record.', 'PAYMENT_ID_MISMATCH');
                  return;
                }

                if (['confirmed', 'paid'].includes(apiStatus)) {
                  // mark success and populate details from bill (prefer latest values, fallback to provided)
                  this.paymentData = Object.assign({}, this.paymentData, {
                  amount: latest.fee || latest.amount || this.paymentData.amount || amount,
                  txn_id: latest.transaction_code || txnId || this.paymentData.txn_id,
                  approval: latest.approval_code || latest.approval || '',
                  paid_at: latest.paid_at || this.paymentData.paid_at, user_id: latest.applicant_id || this.paymentData.user_id
                  });
                  this.paymentSuccess = true;
                  this.isProcessing = false;
                } else if (['due', 'assigned', 'pending'].includes(apiStatus)) {
                  this.showError('Payment not completed yet. Current bill status: ' + apiStatus.toUpperCase(), 'NOT_PAID');
                } else {
                  // Unknown status treat as error
                  this.showError('Payment status: ' + (apiStatus || 'UNKNOWN'), 'UNKNOWN_STATUS');
                }
              } 
              else {
                // Bill number mismatch - consider this an error unless backend URL provided params were authoritative
                this.showError('Bill number does not match latest record. Please check your payment status.', 'BILL_MISMATCH');
              }
              return;
            } else {
              this.showError('Application ID missing; cannot verify bill', 'NO_APP_ID');
              return;
            }
          } catch (err) {
            console.error('Error fetching bill info:', err);
            this.showError('Unable to verify bill status. Please contact helpdesk.', 'BILL_FETCH_ERROR');
            return;
          }

        } else {
          // No applicant result
          this.paymentData = {
            bill: bill,
            amount: amount,
            txn_id: txnId,
            approval: '',
            paid_at: new Date().toLocaleString(),
            unit: unit,
            student_name: '',
            father_name: '',
            user_id: ''
          };
          iziToast.error({
            title: 'Error',
            message: 'Invalid response format',
          })
          // Show generic success with caution removed; instead show error
          this.showError('Invalid applicant data returned from server', 'INVALID_RESPONSE');

        }

      } catch (error) {
        console.error('Error fetching applicant details:', error);
        this.loadingError = error.message || 'Failed to load applicant details';

        // http://localhost:8080/gce/dashboard/bkash-callback?status=success&paymentID=TR0011GSfCCt31763963582101&bill=99TMXPHYRFG&txnId=CKO8H3POO0&amount=1.00

        // Still show success with available data
        this.paymentData = {
          bill: bill,
          amount: amount,
          txn_id: txnId,
          approval: '',
          paid_at: new Date().toLocaleString(),
          unit: unit,
          student_name: '',
          father_name: '',
          user_id: ''
        };
        // console.log(error)

        // If it's a network error or server error, show error message
        // Otherwise redirect to login
        if (error.message.includes('401') || error.message.includes('403')) {
          this.$router.push('/gce/login')
        }
      } finally {
        this.isLoading = false
        this.loading = false
      }
    },

    showError(reason, code = '') {
      this.isProcessing = false;
      this.paymentError = true;
      this.errorData.reason = reason;
      this.errorData.code = code;
      console.error('Payment error:', { reason, code });
    },

    async downloadReceipt() {
      try {
        // Prepare receipt data with student information
        const receiptData = prepareReceiptDataFromLegacy({
          name: this.paymentData.student_name,
          father_name: this.paymentData.father_name,
          userID: this.paymentData.user_id,
          bill_number: this.paymentData.bill,
          amount: this.paymentData.amount,
          txn_id: this.paymentData.txn_id,
          approval: this.paymentData.approval,
          paid_at: this.paymentData.paid_at,
          unit: 'GCE',
          agent: 'bKash',
          status: 'PAID'
        });

        // Generate and download PDF with bKash branding
        await generateReceipt(
          receiptData,
          RECEIPT_PRESETS.BKASH,
          `cu_payment_receipt_bkash_${this.paymentData.bill}.pdf`
        );

      } catch (error) {
        console.error('Error generating receipt:', error);
        alert('Failed to generate receipt. Please try again.');
      }
    },

    retryPayment() {
      this.$router.push('/gce/dashboard');
    },

    goToProfile() {
      this.$router.push('/gce/dashboard');
    }
  }
}
</script>

<style scoped>
.bkash-callback-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #E2136E 0%, #D91A5B 50%, #C71355 100%);
  padding: 20px;
}

.callback-container {
  width: 100%;
  max-width: 700px;
}

/* Loading State */
.processing-state {
  background: white;
  border-radius: 15px;
  padding: 60px 40px;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.loader-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.payment-loader {
  margin-bottom: 30px;
}

.spinner {
  width: 80px;
  height: 80px;
  border: 8px solid #f3f3f3;
  border-top: 8px solid #E2136E;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.processing-title {
  color: #333;
  margin-bottom: 15px;
  font-size: 28px;
  font-weight: 600;
}

.processing-text {
  color: #666;
  font-size: 18px;
  margin-bottom: 10px;
}

.processing-subtext {
  color: #999;
  font-size: 14px;
  font-style: italic;
}

/* Success State */
.success-state {
  background: white;
  border-radius: 15px;
  padding: 50px 40px;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.success-icon {
  margin-bottom: 25px;
}

.success-icon i {
  font-size: 80px;
  color: #28a745;
}

.success-title {
  color: #28a745;
  font-size: 32px;
  margin-bottom: 15px;
  font-weight: 700;
}

.success-message {
  color: #666;
  font-size: 18px;
  margin-bottom: 35px;
}

.payment-details {
  background: #f8f9fa;
  border-radius: 10px;
  padding: 25px;
  margin-bottom: 30px;
  text-align: left;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #dee2e6;
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  font-weight: 600;
  color: #495057;
}

.detail-value {
  color: #212529;
  font-weight: 500;
}

/* Error State */
.error-state {
  background: white;
  border-radius: 15px;
  padding: 50px 40px;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.error-icon {
  margin-bottom: 25px;
}

.error-icon i {
  font-size: 80px;
  color: #dc3545;
}

.error-title {
  color: #dc3545;
  font-size: 32px;
  margin-bottom: 15px;
  font-weight: 700;
}

.error-message {
  color: #666;
  font-size: 18px;
  margin-bottom: 30px;
}

.error-details {
  margin-bottom: 30px;
  text-align: left;
}

.error-details .alert {
  margin-bottom: 15px;
  padding: 15px;
  border-radius: 8px;
}

.help-text {
  text-align: left;
  background: #f8f9fa;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 30px;
}

.help-text h5 {
  color: #495057;
  margin-bottom: 15px;
  font-weight: 600;
}

.help-text ul {
  color: #666;
  line-height: 1.8;
  padding-left: 20px;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
}

.action-buttons .btn {
  padding: 12px 30px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.action-buttons .btn-primary {
  background: #E2136E;
  color: white;
}

.action-buttons .btn-primary:hover {
  background: #C71355;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(226, 19, 110, 0.4);
}

.action-buttons .btn-secondary {
  background: #6c757d;
  color: white;
}

.action-buttons .btn-secondary:hover {
  background: #5a6268;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(108, 117, 125, 0.4);
}

/* Responsive */
@media (max-width: 768px) {
  .bkash-callback-wrapper {
    padding: 10px;
  }

  .processing-state,
  .success-state,
  .error-state {
    padding: 30px 20px;
  }

  .processing-title,
  .success-title,
  .error-title {
    font-size: 24px;
  }

  .processing-text,
  .success-message,
  .error-message {
    font-size: 16px;
  }

  .spinner {
    width: 60px;
    height: 60px;
  }

  .success-icon i,
  .error-icon i {
    font-size: 60px;
  }

  .action-buttons {
    flex-direction: column;
  }

  .action-buttons .btn {
    width: 100%;
  }

  .detail-row {
    flex-direction: column;
    gap: 5px;
  }
}
</style>
